module.exports = __webpack_public_path__ + "static/media/Frame.4c976365.jpg";